import { marked } from 'marked'

/***
 * Search subString in Array and return found element.
 * @param array
 * @return string || null
 */

export const searchSubStringInArray = (array: string[]) => (name: string) => array.find(item => item.includes(name)) || null

export const markdownToHtml = (markdown: string): string => {
  const config = {
    breaks: true
  }

  if (markdown) {
    marked.use({
      tokenizer: {
        heading() {}
      }
    })

    return marked(markdown, config)
  }

  return ''
}

/***
 * Get cookie value
 * @return string || undefined
 * @param name
 * @param stringCookie
 */

export const getCookie = (name:string, stringCookie: string = '') => {
  const cookies = stringCookie || document?.cookie
  const matches = cookies.match(new RegExp(
    '(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'
  ))

  return matches ? decodeURIComponent(matches[1]) : undefined
}

/***
 * Set cookie value
 * @return void
 * @param name
 * @param value
 * @param options
 */

export const setCookie = (name:string, value:string, options:any = {}):void => {
  options = {
    path: '/',
    ...options
  }

  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString()
  }

  let updatedCookie = encodeURIComponent(name) + '=' + encodeURIComponent(value)

  for (const optionKey in options) {
    updatedCookie += '; ' + optionKey
    const optionValue = options[optionKey]
    if (optionValue !== true) {
      updatedCookie += '=' + optionValue
    }
  }

  document.cookie = updatedCookie
}

/**
 * Delete cookie key and value
 * @return void
 * @param name
 */

export const deleteCookie = (name:string):void => {
  setCookie(name, '', {
    'max-age': -1
  })
}

/***
 * Return the ranked string
 * @param rating
 * @param index
 * @return string
 */
export const getRating = (rating: string, index: number): string => {
  return rating.split('/')[index]
}

/**
 * Get Icon from a sprite
 * @param sprite
 */
export const getIconFromSprite = (sprite: any): Function => (name: String): String => `${sprite}#icon-${name}`

/**
 * Get a random number value in between start and end values
 * @param start
 * @param end
 */
export const getRandomNumber = (start: number, end: number): number => Math.floor(Math.random() * end) + start

export const isProd = () => process.env.NODE_ENV === 'production'

/**
 * Get base url
 */
// @ts-ignore
export const getBaseUrl = () => isProd() ? process.env.PROD_BASE_URL : process.env.DEV_BASE_URL

export const gbLocalStorage = {
  get(key: string) {
    const localValue = localStorage.getItem(key)

    return localValue ? JSON.parse(localValue) : undefined
  },
  set(key, data) {
    localStorage.setItem(key, JSON.stringify(data || null))
  },
  remove(key) {
    localStorage.removeItem(key)
  }
}

export const declensionOfNoun = (arr: any[]) => (count: number) => {
  return arr[
    (count % 100 > 4 && count % 100 < 20) ? 2 : [2, 0, 1, 1, 1, 2][(count % 10 < 5) ? Math.abs(count) % 10 : 5]
  ]
}

export const firstLetterUpperCase = (str) => {
  if (str) {
    return str.charAt(0).toUpperCase() + str.slice(1)
  }
}

export const downloadFile = (file) => {
  if (file) {
    try {
      const blob = new Blob([file], { type: file.mimeType })
      const url = window.URL?.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', file.name || file.filename || 'file')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      window.URL.revokeObjectURL(url)
    } catch (e) {
      console.warn(e)
    }
  }
}

export function getConfig(jwt: any) {
  return { headers: {
      Authorization: jwt,
      common: { Authorization: null }
    }
  }
}
